import React, { useState } from "react";
import { FaClipboardList, FaPlusCircle, FaCheckCircle } from "react-icons/fa";

const TaskList = ({ tasks, onTaskComplete, onAddTask }) => {
  const [newTask, setNewTask] = useState("");

  const handleAddTask = () => {
    if (newTask.trim()) {
      onAddTask({
        id: Date.now(),
        description: newTask,
        completed: false,
        timestamp: new Date().toLocaleString(),
      });
      setNewTask("");
    }
  };

  return (
    <div className="p-4 bg-white rounded-lg">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <FaClipboardList className="text-yellow-500 text-4xl" />
          <h3 className="text-xl font-semibold text-gray-800">Tasks</h3>
        </div>
        <button
          onClick={handleAddTask}
          className="flex items-center space-x-2 px-4 py-2 bg-yellow-500 text-white rounded-md hover:bg-yellow-600"
        >
          <FaPlusCircle />
          <span>Add Task for me</span>
        </button>
      </div>

      {/* Input for New Task */}
      <div className="mb-4">
        <input
          type="text"
          value={newTask}
          onChange={(e) => setNewTask(e.target.value)}
          placeholder="Enter a new task..."
          className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500"
        />
      </div>

      {/* Task List */}
      <ul className="space-y-4">
        {tasks.length === 0 ? (
          <p className="text-gray-500">No tasks assigned yet.</p>
        ) : (
          tasks.map((task) => (
            <li
              key={task.id}
              className={`p-4 border rounded-lg ${
                task.completed
                  ? "bg-green-50 border-green-200"
                  : "bg-gray-50 border-gray-200"
              } shadow-sm flex items-center justify-between`}
            >
              <div>
                <div className="text-sm text-gray-500">{task.timestamp}</div>
                <p
                  className={`text-gray-800 mt-2 ${
                    task.completed ? "line-through text-green-700" : ""
                  }`}
                >
                  {task.description}
                </p>
              </div>
              {!task.completed && (
                <button
                  onClick={() => onTaskComplete(task.id)}
                  className="flex items-center space-x-2 px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
                >
                  <FaCheckCircle />
                  <span>Complete</span>
                </button>
              )}
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

export default TaskList;
